import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { enviroment } from "src/environments/environment";
import { CarsManufactureModel } from "../model/cars-manufacture";

@Injectable({providedIn: 'root'})
export class CarsManufacture {
  httpOptions: {};
  fipeUrl: string;

  constructor(private http: HttpClient) {

    let idToken = sessionStorage.getItem('idToken') || "";
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };
    this.fipeUrl = enviroment.BASE_URL_API + '/api/fipe';

  }

  getCarList(): Observable<CarsManufactureModel[]> {

    return this.http.get<CarsManufactureModel[]>(this.fipeUrl + '/brands', this.httpOptions).pipe(tap());

  }

  getCarModels(idModel: string): Observable<CarsManufactureModel[]> {

    return this.http.get<CarsManufactureModel[]>(this.fipeUrl + '/brands/' + idModel + '/models', this.httpOptions).pipe(tap());

  }

}
